import { WebhookEvent, WebhooksState } from "../types";

const state: WebhooksState = {
  currentWebhook: {
    event: WebhookEvent.APPLICANT_PROCESSED,
    name: "",
    url: "",
    description: "",
    enabled: false,
    secret: "",
    contentType: "",
    useContentType: false,
  },
  currentWebhookAttempts: {
    hasNextPage: false,
    hasPreviousPage: false,
    items: [],
    totalPages: 1,
    totalItems: 1,
    pageIndex: 1,
  },
  webhooks: {
    hasNextPage: false,
    hasPreviousPage: false,
    items: [],
    totalItems: 1,
    totalPages: 1,
    pageIndex: 1,
  },
  viewing: "all",
  totalAttempts: 1,
  totalSucceededAttempts: 1,
  totalFailedAttempts: 1,
};

export default state;
